<template>
  <div>
    <!-- 导航 -->
    <!-- <Nav></Nav> -->
    <!-- <input type="input"> -->
    <!-- {{ this.$route }} -->
    <router-view v-if="isRouterAlive" :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: '',
  components: {
    // 导航
    // Nav,
    // 底部
    // Buttom
  },
  computed: {},
  mounted() {
    // 检测设备类型
    // const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // // console.log(isMobileDevice)
    // // 判断设备类型并重定向到移动端页面
    // if (isMobileDevice) {
    // return window.location.href = 'https://www.baidu.com/';
    // }
    // console.log(this.$route);

  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  destroyed() {
    window.removeEventListener('beforeunload')
    window.removeEventListener('unload')
  }
}
</script>
<style lang=scss>
/* // @media screen and (min-width:1200px)and (max-width: 1300px) {
//   * {
//     margin: 0;
//     padding: 0;
//     font-size: 16px;
//     font-family: '微软雅黑';
//   }
// } */

// @media screen and (min-width:960px) and (max-width:1200px){
* {
  margin: 0;
  padding: 0;
  // font-size: 12px;
  font-family: '微软雅黑';
}

html {
  font-size: 12px;
}

// @media screen and (min-width: 1550px) {
//   html {
//     font-size: 12px;
//   }
// }

// @media screen and (max-width: 1550px) {
//   html {
//     font-size: 10px;
//   }
// }
button {
  cursor: pointer;
}

.noneBox {
  height: 80px;
  // background: #026bbc;
}

.box {
  position: relative;
  // z-index: 998;
  z-index: 19;
}

.message_poup_index {
  z-index: 9999 !important;
}


ul {
  list-style: none;
}

.flex {
  display: flex;
}


tr {
  border-bottom: 0.02rem solid #e6e9f4 !important;

  &:last-child {
    border: 0;
  }
}

tbody {
  tr {
    &:last-child {
      border: 0 !important;
    }
  }
}

.ai_title_new {
  font-size: 28px;
  font-weight: bold;
  background: linear-gradient(90deg, rgba(0, 130, 252, 1) 0%, rgba(237, 131, 107, 1) 100%);
  /* 渐变背景色 */
  -webkit-background-clip: text;
  /* 适用于 WebKit 浏览器 */
  -moz-background-clip: text;
  /* 适用于 Firefox 浏览器 */
  background-clip: text;
  /* 适用于大部分现代浏览器 */
  color: transparent;
  /* 隐藏文字颜色 */
  display: inline-block;
  /* 使背景裁剪到文字 */
}
</style>